var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._g({class:['input', { readonly: _vm.readonly }],attrs:{"id":_vm.id,"type":"range","readonly":_vm.readonly,"required":_vm.required,"min":_vm.min,"max":_vm.max,"step":_vm.step},domProps:{"value":_vm.value}},_vm.inputListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }